import get from 'lodash/get';

import { getSelectedBranchSelector } from 'redux/modules/slot-booking/selectors/get-selected-branch';
import { addUserDimension } from 'redux/middleware/custom-dimensions/dimensions/actions';

const addBranchId = state =>
  addUserDimension('branch_id', get(getSelectedBranchSelector(state), 'id'));

export default addBranchId;
